import { TeamArmyView } from './TeamArmyView';

export class SelectTeamArmiesView {
  size: number;
  armies: Array<TeamArmyView>;
  hasError: boolean;
  isArmiesLoading: boolean;
  isLoading: boolean;
  teamName: string;
  teamArmies: Array<TeamArmyView>;

  constructor(params: SelectTeamArmiesViewParams) {
    this.size = params.size;
    this.armies = params.armies;
    this.hasError = params.hasError;
    this.isArmiesLoading = params.isArmiesLoading;
    this.isLoading = params.isLoading;
    this.teamName = params.teamName;
    this.teamArmies = params.teamArmies;
  }
}

export type SelectTeamArmiesViewParams = {
  size: number;
  armies: Array<TeamArmyView>;
  hasError: boolean;
  isArmiesLoading: boolean;
  isLoading: boolean;
  teamName: string;
  teamArmies: Array<TeamArmyView>;
};
